<app-default
  [id]="id"
  [title]="title"
  [specs]="specs"
  [price]="price"
  [photo]="photo"
  [discount]="discount"
  *ngIf="(isDesktop | async); else mobile"
></app-default>

<ng-template #mobile>
  <app-mobile
    [id]="id"
    [title]="title"
    [specs]="specs"
    [price]="price"
    [photo]="photo"
    [discount]="discount"
  ></app-mobile>
</ng-template>
